import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateSettingsPage,
  getSettingsListAll,
} from "../../../redux/settings/action";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import { settingsUpdateValidation } from "../../Constant/constant";



const UpdateSettings = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

  const settingsListData = useSelector(
    (state) => state?.reusableSlice?.settingsListData
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      referral_duration: settingsListData?.referral_duration || "",
      referral_duration_type: settingsListData?.referral_duration_type || "",
      referral_percentage: settingsListData?.referral_percentage || "",
    },
    validationSchema: settingsUpdateValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: settingsListData?.id,
    };
    dispatch(UpdateSettingsPage(data, setLoading));
  };

  useEffect(() => {
    dispatch(getSettingsListAll());
  }, [dispatch]);

  const handleDurationChange = (e) => {
    const value = Number(e.target.value);
    formik.setFieldValue("referral_duration_type", value);
  };
  
  return (
    <div className="">
        <h3 className="pb-3">Referral Info</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>Referral Duration</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter duration"
              name="referral_duration"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.referral_duration}
            />
            {formik.touched.referral_duration &&
            formik.errors.referral_duration ? (
              <div className="error">{formik.errors.referral_duration}</div>
            ) : null}
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="referral_duration_type">
              Referral Duration Type
            </label>
            <select
              id="referral_duration_type"
              name="referral_duration_type"
              className="form-control"
              onChange={handleDurationChange}
              onBlur={formik.handleBlur}
              value={formik.values.referral_duration_type}
            >
              <option value="">Select Duration type</option>
              <option value="1">Days</option>
              <option value="2">Weeks</option>
              <option value="3">Months</option>
              <option value="4">Years</option>
            </select>
            {formik.touched.referral_duration_type &&
            formik.errors.referral_duration_type ? (
              <div className="error">
                {formik.errors.referral_duration_type}
              </div>
            ) : null}
          </div>

          <div className="col-md-4 form-group">
            <label>Referral Amount (SAR)</label>
            <input
            min="0"
              type="number"
              className="form-control"
              placeholder="Enter amount"
              name="referral_percentage"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.referral_percentage}
            />
            {formik.touched.referral_percentage &&
            formik.errors.referral_percentage ? (
              <div className="error">{formik.errors.referral_percentage}</div>
            ) : null}
          </div>
        </div>
        <button
          className="submit-btn d-block mx-auto mt-3  "
          style={{ width: "max-content" }}
          type="submit"
        >
          {!loading ? "Submit" : <Spinner />}
        </button>
      </form>
    </div>
  )
}

export default UpdateSettings
